/**
 * 작성자 : 김광민
 * 날짜 : 2024.03.05
 * 기능 : 상태를 토글할 수 있는 칩 형태의 버튼 컴포넌트
 */

import styled from 'styled-components';

const Root = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 2.5rem;
  background-color: var(--tonal);
  padding-right: 1rem;
  padding-left: 0.5rem;
  border-radius: 2rem;
  gap: 0.375rem;
  border: 2px solid var(--outline);
  .material-symbols-rounded {
    font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    color: var(--outline-em);
  }
  .text {
    color: var(--text-disabled);
    font-size: 0.875rem;
    letter-spacing: normal;
  }
  &.isClicked {
    background-color: var(--tonal-blue);
    border-color: var(--tonal-deep-blue);
    &:hover {
      /* background-color: var(--tonal-deep-blue); */
    }
    .material-symbols-rounded {
      color: var(--primary);
    }
    .text {
      color: var(--filled-blue-deep);
    }
  }
`;

type Props = {
  onClick: () => void;
  status: boolean;
  text: string;
};

const CheckChipButton = ({ onClick, status, text }: Props) => {
  return (
    <Root role='button' tabIndex={0} onClick={onClick} className={status ? 'isClicked' : ''}>
      <span className='material-symbols-rounded'>check_circle</span>
      <span className='text'>{text}</span>
    </Root>
  );
};

export default CheckChipButton;
